import { onceConsented } from "@telia/b2x-cookie-consent";
import {
  inject as injectMedallia,
  virtualPageView as virtualPageViewMedallia,
} from "@telia/b2x-medallia";
import { inject as injectMedalliaDXA } from "@telia/b2x-medallia-dxa";
import { rule } from "@telia/b2x-url-segments";

import { MEDALLIA_ID } from "../constants";
import { w } from "../util";
import { onVirtualPageView } from "./virtual-page-view";

export const initMedallia = () => {
  onVirtualPageView(virtualPageViewMedallia);

  onceConsented("C0002", "Follow user session and launch surveys via medallia").then(() => {
    if (w) {
      const r = rule(new URL(window.location.href));
      let medallia = true;

      if (r.pathStartsWith(["/mitt-telia/whisbi-support"]) || (r.isPrivate && r.isB2B)) {
        medallia = false;
      }

      // include individual paths from what excluded above
      const isPathIncluded =
        r.pathEndsWith(["/foretag/mybusiness/start"]) ||
        (r.pathStartsWith(["/foretag/mybusiness"]) &&
          (r.pathEndsWith([
            "/bestall/formaner",
            "/mobilabonnemang",
            "/mobiltelefoner",
            "/tillbehor",
            "/bredband",
            "/emn",
            "/touchpoint-plus-eftermarknad",
            "/abonnemang",
            "/skapa-overlatelse",
            "/notifieringar",
            "/support/arenden"
          ]) ||
            r.pathIncludes([
              "/din-bestallning",
              "/bekraftelse",
              "/mobil-telefoni/detaljer",
              "/mobilt-bredband/detaljer",
              "/abonnemang/produkt/",
            ])));

      if (isPathIncluded) {
        medallia = true;
      }

      const dxa = r.isPublic;

      if (medallia) {
        injectMedallia(MEDALLIA_ID);
      }

      if (dxa) {
        injectMedalliaDXA();
      }
    }
  });
};
